module.exports = __webpack_public_path__ + "/static/assets/af2202211ca1873edb949012dab6f9d1.svg";